import type { IconNode } from '../types';

/**
 * @name toolbox-2
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNOCA3VjVhMiAyIDAgMCAxIDItMmg0YTIgMiAwIDAgMSAyIDJ2MiIgLz4KICA8cGF0aCBkPSJNNCAyMWEyIDIgMCAwIDEtMi0ydi03YzAtLjYuMy0xLjMuNy0xLjdsMi42LTIuNkM1LjcgNy4zIDYuNCA3IDcgN2gxMGMuNiAwIDEuMy4zIDEuNy43bDIuNiAyLjZjLjQuNC43IDEuMi43IDEuN3Y3YTIgMiAwIDAgMS0yIDJaIiAvPgogIDxwYXRoIGQ9Ik0yIDE0aDIwIiAvPgogIDxwYXRoIGQ9Ik05IDE2di00IiAvPgogIDxwYXRoIGQ9Ik0xNSAxNnYtNCIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/toolbox-2
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const toolbox2: IconNode = [
  ['path', { d: 'M8 7V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2', key: 'gxrri' }],
  [
    'path',
    {
      d: 'M4 21a2 2 0 0 1-2-2v-7c0-.6.3-1.3.7-1.7l2.6-2.6C5.7 7.3 6.4 7 7 7h10c.6 0 1.3.3 1.7.7l2.6 2.6c.4.4.7 1.2.7 1.7v7a2 2 0 0 1-2 2Z',
      key: 'pe1kyz',
    },
  ],
  ['path', { d: 'M2 14h20', key: 'myj16y' }],
  ['path', { d: 'M9 16v-4', key: '9nxvhi' }],
  ['path', { d: 'M15 16v-4', key: '1edpb2' }],
];

export default toolbox2;
